import React from "react"

import BundledPaymentsLayout from "../components/bundled-payments/layout"
import SectionHero from "../components/bundled-payments/cms-team/section-hero"
import SectionChallenges from "../components/bundled-payments/cms-team/section-challenges"
import SectionHowItWorks from "../components/bundled-payments/cms-team/section-how-it-works"
import SectionResults from "../components/bundled-payments/cms-team/section-results"
import SectionTrust from "../components/bundled-payments/cms-team/section-trust"
import SectionHelp from "../components/bundled-payments/cms-team/section-help"
import SectionCta from "../components/bundled-payments/cms-team/section-cta"

const CmsTeamPage = ({ location }) => (
  <BundledPaymentsLayout
    location={location}
    title="CMS TEAM"
    description="TEAM holds hospitals accountable for surgical episodes through 30 days after discharge. See where you stand against target and what to change."
    footerNote="Results vary by hospital. Reconciliation outcomes depend on CMS methodology, patient mix, and the actions each hospital takes. Avant-garde Health does not guarantee reconciliation results."
    pageId="team"
  >
    <SectionHero />
    <SectionChallenges />
    <SectionHowItWorks />
    <SectionResults />
    <SectionTrust />
    <SectionHelp />
    <SectionCta />
  </BundledPaymentsLayout>
)

export default CmsTeamPage
